const MOBILE_USER_AGENT_PATTERN = /Android|iPhone|iPad|iPod|Mobile|Tablet|Silk|Kindle|webOS|BlackBerry|Opera Mini|IEMobile/i;

/**
 * Whether the browser is running on a phone or tablet, regardless of screen width.
 *
 * Width alone can't answer this: an iPad renders the full desktop layout. iPadOS Safari
 * also reports a desktop "Macintosh" user agent by default, so a Mac user agent with a
 * multi-touch screen is treated as an iPad (no shipping Mac has a touchscreen).
 */
export const isMobileDevice = ({ userAgent, maxTouchPoints }: Pick<Navigator, 'userAgent' | 'maxTouchPoints'> = navigator) =>
  MOBILE_USER_AGENT_PATTERN.test(userAgent)
  || (/Macintosh/.test(userAgent) && maxTouchPoints > 1);
